/* SignUpPrompt.tsx generated by @compiled/babel-plugin v0.38.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./SignUpPrompt.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import SuccessContainer from './SuccessContainer';
var buttonContainerStyles = null;
export default (function (_ref) {
  var onAnswer = _ref.onAnswer;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var answeredWith = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setPending(answer ? 'yes' : 'no');
            _context.next = 3;
            return onAnswer(answer);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setPending, onAnswer]);
  var isDisabled = Boolean(pending);
  return /*#__PURE__*/React.createElement(SuccessContainer, null, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, "Thanks for your feedback"), /*#__PURE__*/React.createElement(Box, {
    paddingBlockStart: "space.150"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "Are you interested in participating in our research?"), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "Sign up for the", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.atlassian.com/research-group",
    target: "_blank"
  }, "Atlassian Research Group"), ' ', "and we may contact you in the future with research opportunities."))), /*#__PURE__*/React.createElement("div", {
    className: ax(["_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"])
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: function onClick() {
      return answeredWith(false);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'no'
  }, "No, thanks"), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: function onClick() {
      return answeredWith(true);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'yes'
  }, "Yes, sign me up")));
});